// extracted by mini-css-extract-plugin
module.exports = {"component":"QueuedModals_component__ck2FT","open":"QueuedModals_open__SXV_c"};